export type Privacy = 'PRIVATE' | 'PUBLIC'
export const privacyMap = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
} as const
